// Textes liés aux aspects légaux
export const LEGAL_TEXTS = {
  cgu: 'Conditions Générales d\'Utilisation',
  privacyPolicy: 'Politique de Confidentialité',
  legalNotices: 'Mentions Légales',
  lastUpdated: 'Dernière mise à jour',
  
  // CGU Content
  cguTitle: 'Conditions Générales d\'Utilisation',
  cguSubtitle: 'Plateforme de Gestion de capteurs',
  
  // CGU Sections
  sections: {
    article1: {
      title: '1. Acceptation des Conditions',
      content: `En accédant et en utilisant cette plateforme de gestion, vous acceptez d'être lié par ces Conditions Générales d'Utilisation. Si vous n'acceptez pas ces conditions, veuillez ne pas utiliser la plateforme.`
    },
    
    article2: {
      title: '2. Description de la Plateforme',
      content: `Cette plateforme vous permet de :
• Surveiller les capteurs
• Consulter les données
• Gérer les alertes et notifications
• Exporter les données pour analyse`
    },
    
    article3: {
      title: '3. Responsabilités de l\'Utilisateur',
      content: `Vous vous engagez à :
• Utiliser la plateforme uniquement à des fins professionnelles légitimes
• Garder vos identifiants de connexion sécurisés
• Signaler immédiatement tout problème de sécurité
• Respecter les lois et réglementations applicables`
    },
    
    article4: {
      title: '4. Données et Confidentialité',
      content: `Nous nous engageons à protéger vos données :
• Vos données sont traitées conformément aux lois sur la confidentialité applicables
• Nous mettons en place des mesures de sécurité appropriées
• Votre organisation garde la propriété des données
• Nous ne partagerons pas vos données avec des tiers sans consentement`
    },
    
    article5: {
      title: '5. Disponibilité du Service',
      content: `Nous nous efforçons de maintenir la disponibilité de la plateforme mais ne pouvons garantir un service ininterrompu. La plateforme peut être temporairement indisponible pour maintenance ou raisons techniques.`
    },
    
    article6: {
      title: '6. Limitation de Responsabilité',
      content: `La plateforme est fournie "en l'état" sans garanties. Nous ne sommes pas responsables de :
• Les décisions basées sur les données de la plateforme
• Les dysfonctionnements des capteurs
• Les erreurs d'interprétation des données
• Les interruptions de service`
    },
    
    article7: {
      title: '7. Modifications',
      content: `Nous pouvons mettre à jour ces conditions de temps à autre. L'utilisation continue de la plateforme après les modifications constitue l'acceptation des nouvelles conditions.`
    },
    
    article8: {
      title: '8. Contact',
      content: `Pour toute question concernant ces conditions ou la plateforme, veuillez contacter l'administrateur ou bien la personne responsable de votre organisation.`
    }
  },
  
  // Footer texts
  footer: {
    allRightsReserved: 'Tous droits réservés',
    copyright: 'Copyright',
  },

  // CGU Acceptance Page
  acceptance: {
    title: 'Acceptation des Conditions Générales d\'Utilisation',
    subtitle: 'Avant de continuer, veuillez prendre connaissance et accepter nos conditions d\'utilisation',
    instructions: 'Veuillez lire attentivement les conditions générales d\'utilisation ci-dessous. Votre acceptation est requise pour accéder à la plateforme.',
    scrollToRead: 'Faites défiler pour lire l\'intégralité du document',
    acceptButton: 'J\'accepte les CGU',
    declineButton: 'Refuser et se déconnecter',
    mustAccept: 'Vous devez accepter les conditions générales d\'utilisation pour continuer.',
    acceptanceDate: 'Conditions acceptées le',
    loading: 'Vérification de l\'acceptation...',
    accepting: 'Acceptation en cours...',
    error: 'Une erreur s\'est produite lors de l\'acceptation des CGU.',
    redirecting: 'Redirection vers l\'application...'
  }
} as const;